<template>
  <div class="tva-background-video">
    <video
      ref="videoEl"
      @mouseenter="togglePlay()"
      @mouseleave="togglePlay()"
      :autoplay="autoPlay || smallscreen"
      :preload="preload"
      muted
      loop
      playsinline
    >
      <source
        :src="`${$baseUrl}videos/${pathToVideo}.mp4#t=0.4`"
        :type="videoType"
      />
    </video>
  </div>
</template>

<script setup>
import { inject, ref, computed, watch } from "@vue/runtime-core";
import useTvaMq from "@/plugins/tvaMq.js";

const props = defineProps({
  pathToVideo: {
    type: String,
    required: true,
  },
  videoType: {
    type: String,
    default: "video/mp4",
  },
  preload: {
    type: String,
    default: "none",
  },
  autoPlay: {
    type: Boolean,
    default: false,
  },
  playing: Boolean,
});
// to make this work in storybook we had to redefine the $baseUrl
const $baseUrl = inject("$baseUrl");
const videoEl = ref(null);

const { $tvaMq } = useTvaMq();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));

function togglePlay() {
  if (videoEl && !props.autoPlay) {
    if (props.playing) {
      videoEl.value.play();
    } else {
      videoEl.value.pause();
    }
  }
}

watch(() => props.playing, togglePlay);
</script>

<style lang="scss" scoped>
.tva-background-video {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;

  video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: 100%;
  }
  // change aspect ratio according to video ratio
  @media (min-aspect-ratio: 16/9) {
    video {
      width: 100%;
      height: auto;
    }
  }
}
</style>
